<template>
    <a-modal
            :visible="visible"
            destroyOnClose
            title='修改密码'
            @cancel="onCancel"
            @ok="onSave"
            width="730px">
        <a-form :form="form" class="custom pick-100 form-input">
            <a-form-item label='当前密码'>
                <a-input type="password" v-decorator="['currentPassword', {rules: [{ required: true, message: '请输入当前密码' }]}]"/>
            </a-form-item>
            <a-form-item label='新密码'>
                <a-input type="password" placeholder="请输入8~20位字符，仅含数字、小写字母、大写字母、特殊字符中的三种及以上"
                         v-decorator="['password', {rules: [{ required: true, message: '请输入新密码' },
                       { validator: onCheckPasswordStrength }]}]">
                </a-input>
            </a-form-item>
            <div style="position: relative;">
                <div class="strength" v-if="passwordStrengthId === 0">
                    <span style="background: #ff0000"></span>
                    <span></span>
                    <span></span>
                    <small>密码强度弱</small>
                </div>
                <div class="strength" v-else-if="passwordStrengthId === 1">
                    <span style="background: orange"></span>
                    <span style="background: orange"></span>
                    <span></span>
                    <small>密码强度一般</small>
                </div>
                <div class="strength" v-else-if="passwordStrengthId >= 2">
                    <span style="background: yellowgreen"></span>
                    <span style="background: yellowgreen"></span>
                    <span style="background: yellowgreen"></span>
                    <small>密码强度强</small>
                </div>
                <div class="strength" v-else>
                    <span></span>
                    <span></span>
                    <span></span>
                    <small>安全等级</small>
                </div>
                <div class="remind">
                    <p v-if="valid.length"><a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" /><span>长度为8~20个字符</span></p>
                    <p v-else><a-icon type="close-circle" style="color: #ff0000;font-weight: 500" /><span>长度为8~20个字符</span></p>

                    <p v-if="valid.noSpaceChinese"><a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" /><span>不能使用空格、中文</span></p>
                    <p v-else><a-icon type="close-circle" style="color: #ff0000;font-weight: 500"/><span>不能使用空格、中文</span></p>

                    <p v-if="valid.mixedChar"><a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" /><span>至少含数字、小写/大写字母、特殊字符中的三种及以上</span></p>
                    <p v-else><a-icon type="close-circle" style="color: #ff0000;font-weight: 500"/><span>至少含数字、小写/大写字母、特殊字符中的三种及以上</span></p>
                </div>
            </div>
            <a-form-item label='再次输入新密码'>
                <a-input type="password" v-decorator="['password2', {rules: [{ required: true, message: '请再次输入新密码' }]}]"/>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import qs from 'qs'
import JSEncrypt from 'jsencrypt'
import passwordStrength from 'check-password-strength'

export default {
  name: 'PasswordEdit',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      passwordStrengthId: null,
      form: this.$form.createForm(this),
      valid: {
        length: false,
        noSpaceChinese: false,
        mixedChar: false
      }
    }
  },
  methods: {
    encryptedData (value) {
      let crypt = new JSEncrypt()
      crypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC02SHT0qJBIYaW+8RPhX4hLmUmNgKRe7eIXabz5PojDOUpmi4qLPcrbRcIcHPFTHmXH9lYQUaELmos5Juv0eglDG06kOHBKH4ipHiBdiIp/eQj4QFarXxVgu9Hn7DQv/bJITW0sHN8hiNJyERQFFI2GzjjyLjOFZu/vtqp56K7MQIDAQAB')
      return crypt.encrypt(value)
    },
    onCheckPasswordStrength (rule, value, cb) {
      const result = passwordStrength.passwordStrength(value)
      this.passwordStrengthId = result.id

      // 长度符合
      if (value.length >= 8 && value.length <= 20) {
        this.valid.length = true
      } else {
        this.valid.length = false
      }

      // 不包含空格、中文
      if (!this.hasChinese(value) && !this.hasSpace(value)) {
        this.valid.noSpaceChinese = true
      } else {
        this.valid.noSpaceChinese = false
      }

      // 数字、小写、大写、特殊至少包含三项
      if (result.contains.length >= 3) {
        this.valid.mixedChar = true
      } else {
        this.valid.mixedChar = false
      }

      let isOk = this.valid.length && this.valid.noSpaceChinese && this.valid.mixedChar
      if (!isOk) {
        cb('请输入8~20位字符，仅含数字、小写字母、大写字母、特殊字符中的三种及以上')
      } else {
        cb()
      }
    },
    onSave: function () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        const that = this
        that.loading = true
        let data = this.form.getFieldsValue()
        data.currentPassword = this.encryptedData(data.currentPassword)
        data.password = this.encryptedData(data.password)
        data.password2 = this.encryptedData(data.password2)

        that.$http.post('/api/v2/user/edit_password.json', qs.stringify(data)).then(function (response) {
          if (response.code === 200) {
            that.loading = false
            that.form.resetFields()
            that.$message.success('修改成功')
            that.$emit('success')
          }
        })
      })
    },
    onCancel () {
      this.passwordStrengthId = null
      this.valid.length = false
      this.valid.noSpaceChinese = false
      this.valid.mixedChar = false
      this.$emit('cancel')
    },
    hasChinese (str) {
      const reg = new RegExp('[\\u4E00-\\u9FA5]+', 'g')
      return reg.test(str)
    },
    hasSpace (str) {
      const reg = new RegExp(/\s/)
      return reg.test(str)
    }
  }
}
</script>

<style scoped>
    .remind{
        position: relative;
        background: #fff6db;
        border: 1px solid #ff9800;
        padding: 8px 12px
    }
    /deep/ .pick-100.form-input .has-error .ant-form-explain::before{
        content: "";
        background-image: url("/oa/img/icon-warning.png");
        width: 12px;
        height: 12px;
        display: inline-block;
        vertical-align: top;
        background-size: 12px;
        margin-top: 4px;
        margin-right: 2px;
    }
    .xtoa-classic-theme .remind, .classic-theme .remind{
        margin-left: 138px;
    }
    /*.remind::before{*/
    /*  content: "";*/
    /*  position: absolute;*/
    /*  left: -20px;*/
    /*  top: 0;*/
    /*  bottom: 0;*/
    /*  margin: auto;*/
    /*  width:0;*/
    /*  height:0;*/
    /*  border-top:10px solid transparent;*/
    /*  border-left:10px solid transparent;*/
    /*  border-right:10px solid #ff9800;*/
    /*  border-bottom:10px solid transparent;*/
    /*}*/
    /*.remind::after{*/
    /*  content: "";*/
    /*  position: absolute;*/
    /*  left: -16px;*/
    /*  top: 0;*/
    /*  bottom: 0;*/
    /*  margin: auto;*/
    /*  width:0;*/
    /*  height:0;*/
    /*  border-top:8px solid transparent;*/
    /*  border-left:8px solid transparent;*/
    /*  border-right:8px solid #fff6db;*/
    /*  border-bottom:8px solid transparent;*/
    /*}*/
    .remind p{
        margin: 0;
        color: #000;
    }
    .remind p span{
        margin-left: 4px;
    }
    .classic-theme .pick-100.form-input /deep/ .ant-form-item .ant-col.ant-form-item-label , .xtoa-classic-theme .pick-100.form-input /deep/ .ant-form-item .ant-col.ant-form-item-label{
        flex: 0 0 138px;
    }

    .pick-100.form-input /deep/ .ant-col.ant-form-item-label{
        padding-bottom: 0;
    }
    /deep/ .ant-col.ant-form-item-label label::after {
        content: ':';
        position: relative;
        top: -0.5px;
        margin: 0 8px 0 2px;
    }
    .strength{
        margin-left: 0;
        width: 300px;
        align-items: center;
        display: flex;
        margin-bottom: 4px;
    }
    .strength span{
        width: 100px;
        height: 10px;
        background: #f1f1f1;
        margin: 0 2px;
    }
    .strength small{
        flex: 0 0 auto;
        width: 82px;
        text-align: center;
    }
    .classic-theme .strength , .xtoa-classic-theme .strength{
        margin-left: 138px;
    }
    /deep/ .pick-100.form-input .has-error .ant-form-explain{
        position: relative;
    }
</style>
